// extracted by mini-css-extract-plugin
export var icon = "d4fc1";